export const FeatureFlags = {
  UPDATED_EM: "updated_em",
  PD_TOPICS: "pd_topics",
};
